import { format, isToday, isYesterday } from 'date-fns';

export const formatRelativeDate = (date) => {
        const d = new Date(date);
        if (isToday(d)) {
                return `Today at ${format(d, 'HH:mm')}`;
        }
        if (isYesterday(d)) {
                return `Yesterday at ${format(d, 'HH:mm')}`;
        }
        return format(d, 'yyyy-MM-dd HH:mm');
};
